import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'pro-sobre',
  templateUrl: './sobre.component.html',
  styleUrls: ['./sobre.component.css']
})
export class SobreComponent implements OnInit {

  constructor(private router: Router, private location: Location) { }

  url = this.router.routerState.snapshot.url;
  code = '10adEZo8aIL5A5SlCRqeYCgwBdTqbcFNVhwPJrzlcHEw'

  ngOnInit() {
  }

  goBack() {
    if (this.url.includes('/#/sobre')) {
      this.router.navigate(["home"]);
    } else {
      this.location.back();
    }

  }

}
